// js.cookie
!function(e){var n=!1;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var o=window.Cookies,t=window.Cookies=e();t.noConflict=function(){return window.Cookies=o,t}}}(function(){function g(){for(var e=0,n={};e<arguments.length;e++){var o=arguments[e];for(var t in o)n[t]=o[t]}return n}return function e(l){function C(e,n,o){var t;if("undefined"!=typeof document){if(1<arguments.length){if("number"==typeof(o=g({path:"/"},C.defaults,o)).expires){var r=new Date;r.setMilliseconds(r.getMilliseconds()+864e5*o.expires),o.expires=r}o.expires=o.expires?o.expires.toUTCString():"";try{t=JSON.stringify(n),/^[\{\[]/.test(t)&&(n=t)}catch(e){}n=l.write?l.write(n,e):encodeURIComponent(String(n)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),e=(e=(e=encodeURIComponent(String(e))).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent)).replace(/[\(\)]/g,escape);var i="";for(var c in o)o[c]&&(i+="; "+c,!0!==o[c]&&(i+="="+o[c]));return document.cookie=e+"="+n+i}e||(t={});for(var a=document.cookie?document.cookie.split("; "):[],s=/(%[0-9A-Z]{2})+/g,f=0;f<a.length;f++){var p=a[f].split("="),d=p.slice(1).join("=");this.json||'"'!==d.charAt(0)||(d=d.slice(1,-1));try{var u=p[0].replace(s,decodeURIComponent);if(d=l.read?l.read(d,u):l(d,u)||d.replace(s,decodeURIComponent),this.json)try{d=JSON.parse(d)}catch(e){}if(e===u){t=d;break}e||(t[u]=d)}catch(e){}}return t}}return(C.set=C).get=function(e){return C.call(C,e)},C.getJSON=function(){return C.apply({json:!0},[].slice.call(arguments))},C.defaults={},C.remove=function(e,n){C(e,"",g(n,{expires:-1}))},C.withConverter=e,C}(function(){})});
// Promo global object
var P = {};    
(function($){
  $(document).ready(function(){
    var G = {};
    
    if($('#ProductJson-gap-product-temp').length){
      window.pData = JSON.parse(document.getElementById('ProductJson-gap-product-temp').innerHTML);
    }
    
    /* shared checkout cookie */
    if (getUrlVars()['sctest'] == 'true'){
      var in30Minutes = 1/48;
      Cookies.set('sctest', 'true', { expires: in30Minutes });
    }
    
    if(Cookies.get('sctest') == 'true'){
      $('#AddToCart-gap-product-temp').click(function(e){
        e.preventDefault();
        var prodvar = $('#ProductID-gap-product-temp').val();
        var prodsku = window.psku[prodvar];
        var qty = $('#qty-data').val();
        if(prodvar.length && qty > 0){
          location.href = 'https://checkout.gap.com.ph/search/?q='+prodsku+'&qty='+qty;
        }
      });
    }
    
    if(getUrlVars()['sctest'] == 'true' || Cookies.get('sctest') == 'true'){
      $('.sister-brands-inner a:not(.active)').click(function(e){
        e.preventDefault();
        var $this = $(this);
        location.href = $this.attr('href') + '?sctest=true';
      });
    }
    
    
    
    var $pop_row = $('#popular-row');
    $pop_row.slick({
      slidesToShow: 5,
      slidesToScroll: 5,
      mobileFirst: false,
      nextArrow : '<button type="button" class="slick-next"></button>',
      prevArrow : '<button type="button" class="slick-prev"></button>',
      variableWidth: false,
      responsive: [
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]

    });
    
    // Datepicker Account Registration
    // $( "#dob" ).datepicker();
    
    
    $("#promo-banner-details .dialogify").on("click",function(){
      $(".modal-popup").addClass("_show");
      if($(".modals-overlay").length == 0)
        $("<div></div>").addClass("modals-overlay").appendTo($(".modals-wrapper"));
    });

    $(".modal-popup .action-close").on("click",function(){
      $(".modal-popup").removeClass("_show");
      $(".modals-overlay").remove();
    });


//     $('.prod-image-section .image-display .display-lists li img').click(function(e){
// //       e.preventDefault();
//       var $this = $(this)

//         if($this.hasClass('zoomed')){
//           $this.removeClass('zoomed')
//           $('.zoomContainer').remove()
          
//         } else{
//           $this.addClass('zoomed')
//           $this.elevateZoom({
//             zoomWindowFadeIn: 300,
//             zoomWindowFadeOut: 300,
//             lensFadeIn: 300,
//             lensFadeOut: 300,
//             loadingIcon: 'http://www.elevateweb.co.uk/spinner.gif'        
//           })
//         }
//     })

    var $pop_product_carousel = $('#popular-product-carousel')
    $pop_product_carousel.slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      mobileFirst: false,
      nextArrow : '<button type="button" class="slick-next"></button>',
      prevArrow : '<button type="button" class="slick-prev"></button>',
      variableWidth: false,
      responsive: [
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    var _init = function () {
      var $widget = this,
          $colorswatch = $('.color .swatch-option'),
          $element = $('.swatch-option-tooltip'),
          timer,
          type = parseInt($colorswatch.attr('option-type'), 10),
          label = $colorswatch.attr('option-label'),
          thumb = $colorswatch.attr('option-tooltip-thumb'),
          value = $colorswatch.attr('option-tooltip-value'),
          $image,
          $title,
          $corner;

      if (!$element.size()) {
        $element = $('<div class="swatch-option-tooltip"><div class="image"></div><div class="title"></div><div class="corner"></div></div>');
        $('body').append($element);
      }

      $image = $element.find('.image');
      $title = $element.find('.title');
      $corner = $element.find('.corner');

      $colorswatch.hover(function () {
        if (!$colorswatch.hasClass('disabled')) {
          timer = setTimeout(
            function () {
              var leftOpt = null,
                  leftCorner = 0,
                  left,
                  $window;
              $image.css({
                'background': 'url("' + thumb + '") no-repeat center', //Background case
                'background-size': 'initial'
              });
              $image.show();
              $title.text(label);
              leftOpt = $colorswatch.offset().left;
              left = leftOpt + $colorswatch.width() / 2 - $element.width() / 2;
              $window = $(window);

              // the numbers (5 and 5) is magick constants for offset from left or right page
              if (left < 0) {
                left = 5;
              } else if (left + $element.width() > $window.width()) {
                left = $window.width() - $element.width() - 5;
              }

              // the numbers (6,  3 and 18) is magick constants for offset tooltip
              leftCorner = 0;

              if ($element.width() < $colorswatch.width()) {
                leftCorner = $element.width() / 2 - 3;
              } else {
                leftCorner = (leftOpt > left ? leftOpt - left : left - leftOpt) + $colorswatch.width() / 2 - 6;
              }

              $corner.css({
                left: leftCorner
              });
              $element.css({
                left: left,
                top: $colorswatch.offset().top - $element.height() - $corner.height() - 18
              }).show();
            },
            200
          );
        }
      }, function () {
        $element.hide();
        clearTimeout(timer);
      });

      $(document).on('tap', function () {
        $element.hide();
        clearTimeout(timer);
      });

      $colorswatch.on('tap', function (event) {
        event.stopPropagation();
      });
    }
    
    if($('body').hasClass('template-product')){
      // color / variant switching
      // window.pData -> global object for product data
      window.pVars = window.pData.variants;
      var $addToCartBtn = $('#AddToCart-gap-product-temp'),
          $productFormID = $('#ProductID-gap-product-temp'),
          $productFormSKU = $('#ProductSKU-gap-product-temp'),
          varslength = window.pVars.length;   

//       function stockBuffer(invCount){
//         var invCount = invCount,
//          buffedInv = 0,
//             prodTags = window.pData.tags,
//             logoTag = (prodTags.indexOf('Logo') > -1 )? true : false,
//             graphictTag = (prodTags.indexOf('Graphic Tees')>-1)? true : false,
//             kidsTag = (prodTags.indexOf('Gap Girls')>-1 || prodTags.indexOf('Gap Toddler Girls')>-1 || prodTags.indexOf('Gap Boys')>-1 || prodTags.indexOf('Gap Toddler Boys')>-1 )? true : false;



//         //Buffer determines if product has certain logo tag by Rengie
//         if(invCount > 0){
//          if(logoTag){
//            buffedInv = invCount - 1;
//          } else if(graphictTag && kidsTag){
//            buffedInv = invCount - 1;
//          } else{
//               buffedInv = invCount;
//             }
//         } else {
//          buffedInv = 0;
//         }
//         return buffedInv;
//       }        

      function getStockText(varid){
        var invCount = window.viq[varid],
            stockText = (invCount > 1) ? ' stocks left' : ' stock left';
//             finalBuff = stockBuffer(invCount);
        if(invCount == 0){
          stockText = "Out of stock";
        } else {
          stockText = 'Only ' + invCount + stockText;
        }
        $('#variant-inventory').text(stockText);

        //Changes the data attirbute of #qty-button with the matching variant inventory stock by Rengie
        var qtyData = $('#qty-button').data("currqty");
        $('#qty-button').data("currqty", invCount)
      }

      function getVarID(opts){
        if(opts.prodtype == "Shoes"){
          // logic for shoes
          var optcolor = opts.color,
              optsize = opts.size;
          for (var a = 0; a < varslength; a++){
            var currVar = window.pVars[a],
                currColor = currVar.option1,
                currSize = currVar.option2
            if(currColor == optcolor && currSize == optsize){
              $productFormID.val(currVar.id);
              getStockText(currVar.id);
            }
          }
        }
      }
      
      function getVarID2(obj){
          for(var a = 0; a < varslength; a++){
            var currVar = window.pVars[a]
            var $len = obj.len,
                $color = obj.color,
                $size = obj.size
            
//               console.log($size + " " + $color + " " + $len)
            
              if($len != null ){
                  if(currVar.option1 == $color && currVar.option2 == $size && currVar.option3 == $len){
                      $productFormID.val(currVar.id);
//                      console.log("Has Id new = " + currVar.id)
                      getStockText(currVar.id)
                  }
              } else {
                  if(currVar.option1 == $color && currVar.option2 == $size){
                      $productFormID.val(currVar.id);
//                     console.log(currVar.id)
                      getStockText(currVar.id)
                  }
              }
          }
      }      

      function updateVarPrice(opts){
        var optid = opts.id;
        for (var a = 0; a < varslength; a++){
          var moneySymbol = "₱";
          var currVar = window.pVars[a],
              salePrice = currVar.price,
              origPrice = currVar.compare_at_price,
              $regPriceSpan = $('#ComparePrice-gap-product-temp'),
              $salePriceSpan = $('#ProductPrice-gap-product-temp'),
              currPrice = theme.Currency.formatMoney(currVar.price, theme.moneyFormat),
              regPrice = theme.Currency.formatMoney(currVar.compare_at_price, theme.moneyFormat);
            
          if(currVar.id == optid){
          // console.log(currVar)
          // console.log(salePrice, ' ', origPrice)
            if(salePrice < origPrice){
              $regPriceSpan.text(regPrice).parent().show();
              $salePriceSpan.closest('.prod-price').addClass('sale')
              $salePriceSpan.text(currPrice);
//               $salePriceSpan.siblings().show()
            } else {
              $regPriceSpan.parent().hide();
              $salePriceSpan.closest('.prod-price').removeClass('sale')
              $salePriceSpan.text(currPrice);
//               $salePriceSpan.siblings().hide()
            }
          }
        }
      }

      
      $(".quantity-select .input-qty.selection").click(function(){
          var $this = $(this),
              $qtydata = $this.children().data('qval'),
              $parent = $this.parent(),
              $inputData = $('#qty-data'),
              $qtyBtn = $("#qty-button")
          var $curqty = $('#qty-button').data("currqty");

            if($qtydata > $curqty){
              var lowestQty = ".input."+$curqty.toString()
              // $this.parent().find(lowestQty).trigger('click')
              $qtyBtn.children().text($curqty)
              $inputData.val($curqty)
              $('#oos-qty').show();
            } else {
              $qtyBtn.children().text($qtydata)
              $inputData.val($qtydata)
              $('#oos-qty').hide();
            }
            $parent.toggle("slide").toggleClass('active')
      })

//       $('.image-carousel .image-lists li').click(function(e){
//           e.preventDefault();
//           var $this = $(this),
//               idx = $this.index(),
//               $label = $('.color .swatch-option'),
//               $swatchcolor = $label.attr('option-label'),
//               $selectedSwatch = $('.color .swatch-option.selected'),
//               $thiscolor = $this.find('img').attr('alt');
//           $this.addClass('active').siblings().removeClass('active');
//           $('.image-display .display-lists li').hide();
//           $('.image-display .display-lists li:eq('+idx+')').show();
        
// //         console.log($thiscolor + " "+ $selectedSwatch.attr('option-label'))
        
//         if($thiscolor != $selectedSwatch.attr('option-label')){
//           $.each($label, function(i, color){
//             var $scolor = $(color).attr('option-label')
//             if($scolor == $thiscolor){
//               $(color).trigger('click')

//             }
//           })
//         }
        
//       });

      $('.color .swatch-option').click(function(e) {
        var $this = $(this);
        // console.log($this.index())
        if($(window).width() <= 768) {
          $('.prod-image-section .display-lists.for-slick').slick('slickGoTo', $this.index());
        }
//         $('.prod-image-section .display-lists.for-slick')
        if (!$this.hasClass('disabled')){

         $('#oos-colsiz').hide();
          
          var $idx = $this.data('swatch-index'),
              $label = $this.attr('option-label');
          $this.addClass('selected').siblings().removeClass('selected');
          // change showcased image group according to color selected
          var $imgGroupMain = $('.img-group:eq('+$idx+').container-zoom').show(),
              $imgGroupPager = $('.img-group.container-pager:eq('+$idx+')').show();

          // console.log($label)
          $('.image-carousel img[alt="'+$label+'"]').first().closest('li').addClass('active').siblings().removeClass('active')  
          $('.image-display .display-lists li:eq('+$('.image-carousel li.active').index()+')').show().siblings().hide()
          
          if($('.image-lists li.active').offset().top == 343.84375){
          $('.image-carousel').scrollTop(0)  
          } else {
          $('.image-carousel').scrollTop($('.image-lists li.active').offset().top)
          }
          
          
//           $('.image-carousel').scrollTop() = $('.image-carousel img[alt="'+$label+'"]').scrollHeight;
//           .first().trigger('click');
          
          
          $imgGroupMain.children().first().trigger('click');
          $imgGroupPager.children().first().trigger('click');
          $imgGroupMain.siblings('.container-zoom').hide();
          $imgGroupPager.siblings('.container-pager').hide();
          // show the selected color on label
          $this.parent().prev().find('.swatch-attribute-selected-option').text($label);
          
          // disable all sizes first
          $('.size .swatch-option, .waist .swatch-option').addClass('disabled');
          $('.waist .swatch-option input').attr('disabled',true);

          if(window.pData.type == "Jeans" || window.pData.type == "Pants"){
            
           
            var colorSizeOptions = [];
            var activeSwatch = $('.size .swatch-option.selected'),
                activeSize = activeSwatch.attr('option-label'),
                activeWidthSwatch = $('.width .swatch-option.selected'),
                activeWidth = activeWidthSwatch.attr('option-label');
            
            activeSwatch.removeClass('selected');
            activeWidthSwatch.removeClass('selected');
            $('.size .swatch-attribute-selected-option').text('');
            $productFormID.val('');
            $addToCartBtn.addClass('disabled').attr('disabled',true);
            $addToCartBtn.find('.cart-button').addClass('disabled').attr('disabled',true); 
            for (var a = 0; a < varslength; a++){
              var currVar = window.pVars[a],
                  currColor = currVar.option1,
                  currSize = currVar.option2,
                  currWidth = currVar.option3;
//               console.log(" Rengie's Log Check Currvar Value: " + currVar )
              if(currColor == $label){
                colorSizeOptions.push(currSize);
                var $size = $('.size .swatch-option[option-label="'+currSize+'"]');
                var $waist = $('.waist .swatch-option[option-label="'+currSize+'"]');
                var $width = $('.width .swatch-option[option-label="'+currWidth+'"]');
                
                var opts = {
                  id: currVar.id
                }
                updateVarPrice(opts);  
                
                if(currVar.available) {
                  $size.removeClass('disabled').addClass('available').children('input').attr('disabled',false);
                  $waist.removeClass('disabled').addClass('available').children('input').attr('disabled',false);
                 $width.removeClass('disabled').addClass('available').children('input').attr('disabled',false);
                  if(activeSize == currSize){
                    getStockText(currVar.id);
                    activeSwatch.addClass('selected');
                    var opts = {
                      id: currVar.id
                    }
                    updateVarPrice(opts);   
                    $productFormID.val(currVar.id);
                    $addToCartBtn.addClass('enabled').attr('enabled',true);
                    // console.log(currVar)
                  }
                } else {
                  if(activeSize == currSize){
                    $('.size .swatch-attribute-selected-option').text('');
                    $productFormID.val('');
                    $addToCartBtn.addClass('disabled').attr('disabled',true);
                    $addToCartBtn.find('.cart-button').addClass('disabled').attr('disabled',true);
                  }
                  $size.addClass('disabled').removeClass('selected')
                  .removeClass('available').children('input')
                  .attr('disabled',true);       
                }
              }
            }

            // check if a size is already selected
            var selectedVarID = $('#ProductID-gap-product-temp').val();
            if ($('.size .swatch-option.selected').length && selectedVarID != ""){
              $addToCartBtn.removeClass('disabled').attr('disabled',false);
              var opts = {
                id: selectedVarID
              }
              updateVarPrice(opts);
              
            }
          } else {
            
            for (var a = 0; a < varslength; a++){
              var currVar = window.pVars[a],
                  currColor = currVar.option1,
                  currSize = currVar.option2,
                  qtyCount = window.viq[currVar.id],
                  $size = $('.size .swatch-option[option-label="'+currSize+'"]');
              var opts = {
                id: currVar.id
              }
              
//               console.log(" Rengie's Log Check Currvar Value: " + currVar )
              
              if(currColor == $label){
                $productFormID.val(currVar.id);
                $addToCartBtn.removeClass('disabled').attr('disabled',false);
                

                if(qtyCount > 0){
                   $size.removeClass('disabled').addClass('available').children('input').attr('disabled',false);
                   updateVarPrice(opts);  
                }
                if(window.viq[currVar.id] != undefined){
                  getStockText(currVar.id);
                }
                
              }
              
            }
            
          }

        } else {
          $('#oos-colsiz').show();

          $addToCartBtn.addClass('disabled').attr('disabled',true);
          $addToCartBtn.find('.cart-button').addClass('disabled').attr('disabled',true); 
          return false;
        }
      });

      
      
      function findAvailableLengths(width){ 
//         console.log('Vailable Lengths in')
        for (var a = 0; a < varslength; a++){
          var currVar = window.pVars[a],
              currColor = currVar.option1,
              currSize = currVar.option2,
              currWidth = currVar.option3;               

          if(currColor == width.color && currSize == width.waist && currVar.available){ 
            
            console.log(currWidth + " " + a)
            var $width = $('.width .swatch-option[option-label="'+currWidth+'"]');
            $width.removeClass('disabled').addClass('available').children('input').attr('disabled',false);

          }
        }
      }
      
      
      
//       $('.size .swatch-option, .bottom_width .swatch-option, .waist .swatch-option').click(function(e) {
// //         console.log("Click worked")
//           console.log(" This is the past ID = " + $productFormID.val())
//           var $this = $(this),
//               productType = $('#productTypeContainer').val(),
//               option2name = $('#option2name').val(),
//               option3name = $('#option3name').val(),
//               swatchType = $('.swatch-top'),
//               selectedColor = swatchType.find('.swatch-option.clr.selected').attr('option-label'),
//               selectedSize = (swatchType.hasClass('waist')) ? swatchType.find('.swatch-option.wst.selected').attr('option-label') : swatchType.find('.swatch-option.sz.selected').attr('option-label'); // waist kapag meron
//           var selectedLength = swatchType.find('.swatch-option.wdth.selected').attr('option-label'); // len kasi reserved word yung length
 
        

//         if (!$this.hasClass('disabled')){ 
//           $('#oos-colsiz').hide();

//           var $idx = $this.index();
//           var $label = $this.attr('option-label')   
//           $('.width .swatch-option').removeClass('selected')         
//           $(this).addClass('selected').siblings().removeClass('selected');    
//           $this.closest('.swatch-top').find('.swatch-attribute-selected-option').text($label); // changed by Rengie 12/Feb/2019
//           var $swatchAttribute = $this.closest('.swatch-attribute');


//           $addToCartBtn.addClass('disabled').attr('disabled',true);
//           $addToCartBtn.children().addClass('disabled').attr('disabled',true);

//           if(swatchType.hasClass('waist')){
//             selectedSize = swatchType.find('.swatch-option.wst.selected').attr('option-label');
//           } else{
//             selectedSize = swatchType.find('.swatch-option.sz.selected').attr('option-label');
//           }

//           if(swatchType.hasClass('color')){
//             selectedColor = swatchType.find('.swatch-option.clr.selected').attr('option-label')
//           }

//           if(swatchType.hasClass('width')){
//             selectedLength = (swatchType.find('.swatch-option.wdth').hasClass('selected')) ? swatchType.find('.swatch-option.wdth.selected').attr('option-label') : null;
//           }          
//           // console.log(selectedLength)
          
//           var variant_values = [];
          
//           $('.swatch-option[data-option-index]').each((i, element) => {
//             var $this = $(element),
//                 index = $this.data('option-index'),
//                 value = $this.find('.swatch-btn input').val();
//             variant_values.push({
//               index: index,
//               value: value
//             });
//           })

//           var objForVar = {
//             color: selectedColor,
//             size: selectedSize, // aka waist
//             len: selectedLength
//           }

//           console.log(objForVar)

//           getVarID2(objForVar); 
//           objForVar.id = $productFormID.val();
//           updateVarPrice(objForVar)

//           var waisted = (option2name.indexOf('Waist') > -1);
//           if(waisted){
//             var waistData = {
//               color: selectedColor,
//               waist: selectedSize
//             }

//             // disable width sizes first
//             $('.width .swatch-option').addClass('disabled').removeClass('available').children('input').attr('disabled',true);
//             findAvailableLengths(waistData)

//             if(selectedSize != null && selectedLength != null){
//               $(this).addClass('selected').siblings().removeClass('selected');
//               $addToCartBtn.removeClass('disabled').attr('disabled',false);
//               $addToCartBtn.children().removeClass('disabled').attr('disabled',false);    
//               // console.log(currVar)

//             } else{

//               $('.width .swatch-option').closest('.swatch-top').find('.swatch-attribute-selected-option').text('')
//               $addToCartBtn.addClass('disabled').attr('disabled',true);
//               $addToCartBtn.children().addClass('disabled').attr('disabled',true);            
//             }
//           } else{
//             console.log(" NOT JEANS IN")
//             if(selectedColor != null || selectedSize != ''){
//               $addToCartBtn.removeClass('disabled').attr('disabled',false);
//               $addToCartBtn.children().removeClass('disabled').attr('disabled',false);
//             }           
//           }

//         } else {
//           $('#oos-colsiz').show();  
//           $addToCartBtn.addClass('disabled').attr('disabled',true);
//           $addToCartBtn.find('.cart-button').addClass('disabled').attr('disabled',true);            
//         }
//       });
    }
  
    
    var swatchtooltip = function (item){ 
      var $element = $('.swatch-option-tooltip'),
          timer,
          $image,
          $title,
          $corner;

      if (!$element.size()) {
        $element = $('<div class="swatch-option-tooltip"><div class="image"></div><div class="title"></div><div class="corner"></div></div>');
        $('body').append($element);
      }

      $image = $element.find('.image');
      $title = $element.find('.title');
      $corner = $element.find('.corner');

      $(document).on('tap', function () {
        $element.hide();
        clearTimeout(timer);
      });
    }
    
    $('#bc-sf-filter-products').on('click','.swatch-option.image',function(e){
      var $this = $(this),
          idx = $this.index(),
          $parent = $this.closest('.product-item'),
          $imgContainer = $parent.find('.img-container');
      $imgContainer.children('img').eq(idx).show().siblings().hide();
      
          // console.log($this + " " + idx + " " + $parent + " " + $imgContainer )
    });
    
    
    var refreshCollection = function(arg){
      if (arg.length == 0) {
        $('.main .category-view').show();
        if (!($('body').hasClass('vendor') || $('body').hasClass('sale'))) {
          $('#pl-product-grid').hide();
        } else {
          var defaultSwatch = $('#default-swatch').text().toString();
          setTimeout(function(){
            jQuery('#bc-sf-filter-products .swatch-option.image').each(function(i,e){
              var newswatch = defaultSwatch.replace("swatch-red", $(e).data('swatch'));
              var swatchbg = 'background-image: url('+newswatch+')';
              $(e).attr('style',swatchbg).attr('option-tooltip-thumb',newswatch);
              swatchtooltip($(e));
            });
//             filswatchtooltip($('.bc-sf-filter-option-swatch-image'));
          },1000);
        }
        setTimeout(function(){
//           filswatchtooltip($('.bc-sf-filter-option-swatch-image'));
        },1000);
      } else {
        $('#pl-product-grid').show();
        $('.main .category-view').hide()
        var defaultSwatch = $('#default-swatch').text().toString();
        setTimeout(function(){
          jQuery('#bc-sf-filter-products .swatch-option.image').each(function(i,e){
            var newswatch = defaultSwatch.replace("swatch-red", $(e).data('swatch'));
            var swatchbg = 'background-image: url('+newswatch+')';
            $(e).attr('style',swatchbg).attr('option-tooltip-thumb',newswatch);
            swatchtooltip($(e));
          });
//           filswatchtooltip($('.bc-sf-filter-option-swatch-image'));
        },1000);
      }
    }

    if ($('body').hasClass('template-collection') || $('body').hasClass('template-search')) {
      refreshCollection(window.location.search);
      $(document).on("click",function(e,d){
        var warg = window.location.search;
        refreshCollection(warg);
      });
      $(document).on('change','.collection-sort__input',function(){
        $(document).trigger('click');
      });
//       filswatchtooltip($('.bc-sf-filter-option-swatch-image'));
      $(document).trigger('click');
    }
    
    if ($('body').hasClass('template-product')) {
      swatchtooltip($('.swatch-option.color'));
      // compare prices show
      window.prodvardata = JSON.parse(document.getElementById('ProductJson-gap-product-temp').innerHTML);
      
      // product detail and shipping calculator tab switches
      $('.data a.switch').click(function(e) {
        e.preventDefault();
        var $this = $(this);
        var $target = $($this.attr('href'));
        $this.parent().addClass('active').siblings('.data.item.title').removeClass('active');
        if (!$target.hasClass('shown')) {
          $target.show().addClass('shown').siblings('.data.item.content').hide().removeClass('shown');
        }
      });
      window.currcartitems = window.cartitems;
      // shipping calculator logic
      $('.action.ship-calc').click(function(e){
        cartitems = 0;
        var $zipInput = $('#pcte');
        var $ziVal = $zipInput.val();
        var isnum = /^\d+$/.test($ziVal);
        var ziplength = $ziVal.length;
        $('#custom-message-error').hide();
        if (isnum && ziplength == 4) {
          var $zip = parseInt($ziVal);
          // check if provincial or metro manila
          window.currAddress = '';
          if ($zip > 1820) {
            for (var i=1;i<79;i++) {
              $currprov = provzip[i].prov;
              $.each(provzip[i].zips,function(zip,zone){
                zip = parseInt(zip);
                if ($zip == zip) {
                  window.currZip = zip;
                  window.currAddress = zone + ', ' + $currprov;
                  i = 78;
                }
              });
            }
          } else {
            for (var i=1;i<18;i++) {
              $currcity = mmzip[i].city;
              $.each(mmzip[i].zips,function(zip,zone){
                zip = parseInt(zip);
                if ($zip == zip) {
                  window.currZip = zip;
                  window.currAddress = zone + ', ' + $currcity;
                  i = 18;
                }
              });
            }
          }
          cartitems = window.currcartitems + parseInt($('#Quantity').val());
          if (window.currAddress.length) {
            // console.log('cartitems: ' + cartitems);
            if ($zip < 1821) {
              if ( cartitems == 1 ){
                $shipcost = 'Php 190.00';
              } else if ( cartitems < 6 ) {
                $shipcost = 'Php 190.00';
              } else {
                $shipcost = 'Php 600.00';
              }
              $dateestimate = '3-5 days';
            } else {
              if ( cartitems == 1 ){
                $shipcost = 'Php 270.00';
              } else if ( cartitems < 6 ) {
                $shipcost = 'Php 270.00';
              } else {
                $shipcost = 'Php 800.00';
              }
              $dateestimate = '5-7 days';
            }
            $('#shipped-info').show().next().hide();
            $('#curr-address').text(window.currAddress);
            $('#date-estimate').text($dateestimate);
            $('#pl-shipping-amount').text($shipcost);
            $('#sip-tab-info').slideDown();
          } else {
            $('#custom-message-error').show();
            $('#sip-tab-info').hide();
          }
        } else {
          $('#custom-message-error').show();
          $('#sip-tab-info').hide();
        }
      });
      
      // change estimate place
      $('#shipped-info a.edit').click(function(e){
        e.preventDefault();
        $('#shipped-info').hide().next().show();
      });
      
      
      // contextualizing for easy use.
      // this function is recently added
      // to address the issue of wrong sizes
      // being added to cart
      var rawProductData = window.prodvardata,
          rpd = rawProductData,
          orgData = {
            colors: [],
            sizes: []
          };
      var variants = rpd.variants,
          l = variants.length,
          colorArr = orgData.colors,
          sizeArr = orgData.sizes
      if (rpd.type == "Shoes") {
        for (var i = 0; i < l; i++) { 
          var currVar = variants[i],
              varColor = currVar.option1,
              varSize = currVar.option2;
          if (currVar.available) {
             if (colorArr.indexOf(varColor) < 0) {
               colorArr.push(varColor);
               var obj = [{size: varSize,id: currVar.id}];
               sizeArr.push(obj);
             } else {
               var colorPos = colorArr.indexOf(varColor);
               sizeArr[colorPos].push({size: varSize,id: currVar.id});
             }
          }
        }
        // make data accessible globally
        window.orgData = orgData;
        // disable add to cart button by default
        var $ctabtn = $('AddToCart-gap-product-temp');
        $ctabtn.attr('disabled',true);
        // use of data on line 245
      }else {
        for (var i = 0; i < l; i++) {
          var currVar = variants[i],
              varColor = currVar.option1;
          if (currVar.available && colorArr.indexOf(varColor) < 0) {
            var obj = [{color: varSize,id: currVar.id}];
              colorArr.push(obj);
          }
        }
        // make data accessible globally
        window.orgData = orgData;
        // disable add to cart button by default
        var $ctabtn = $('AddToCart-gap-product-temp');
        $ctabtn.attr('disabled',true);
      }
      $(window).load(function(){
        // $('.color .swatch-option.available').first().trigger('click');
        $addToCartBtn.children().text('Add To Bag'); //changed by Rengie 21/Feb/19
      });
      
    }
    
    // newsletter signup submit
    $('#newsletter-validate-detail').on('submit',function(e){
      e.preventDefault();
      if ($('.subscribe .confirmation input').is(':checked')) {
        var $this = $('#newsletter-email-val');
        var $val = $this.val();
        $('#mce-EMAIL').val($val);
        $('#mc-embedded-subscribe-form').trigger('submit');
      } else {
        alert('Please tick Privacy Policy checkbox.')
      }
    });
    
    // account creation privacy policy
    $('#authenticationPopup input[type="submit"]').click(function(e){
      e.preventDefault();
      if ($('.fieldset .confirmation input').is(':checked')) {
        $('#form-validate').submit();
      } else {
        alert('Please tick Privacy Policy checkbox.');
      }
    });
    
    // RELATED PRODUCTS
    $.fn.pick = function(how_many) {
      var how_many = how_many || 4;
      // Picking random numbers without repeating. 
      var index_array = [];
      var original_obj_size = this.size();
      for (var i=0; i<original_obj_size; i++) {
        index_array.push(i);
      }
      //+ Jonas Raoni Soares Silva
      //@ http://jsfromhell.com/array/shuffle [rev. #1]
      var shuffle = function(v) {
        for (var j, x, i = v.length; i; j = parseInt(Math.random() * i), x = v[--i], v[i] = v[j], v[j] = x);
        return v;
      };
      function theshuffle(array) {
        var cI = array.length, tV, rI;
        while (0 !== cI) {
          rI = Math.floor(Math.random() * cI);
          cI -= 1;
          tV = array[cI];
          array[cI] = array[rI];
          array[rI] = tV;
        }

        return array;
      }
      var new_index_array = theshuffle(index_array)
      new_index_array.slice(0,how_many);
      

      // Ditching unpicked elements and removing those from the returned set.
      return this.each(function(i) {
         if ($.inArray(i,new_index_array) === -1) {
            $(this).remove();
         }
      }).filter(function() {
        if (this.parentNode === null) {
          return false;
        }
        else {
          return true;
        }
      });

    };
    
    jQuery.fn.yesshuffle = function () {
      var j;
      for (var i = 0; i < this.length; i++) {
        j = Math.floor(Math.random() * this.length);
        $(this[i]).before($(this[j]));
      }
      return this;
    };
    
    $('.products-related .product-item').pick(4);
    $('.products-related .product-item').yesshuffle();
    
    window.prodlistbuilt = false;
    
    // 
    $(window).on("load",function(){  
      var elem = document.querySelector('.product-items');
      if(elem !== null){
        if($('#bc-sf-filter-bottom-pagination').length){

        }
        $("#bc-sf-filter-tree").addClass("filter-options");
      
        $(".filter-title").on("click",function(){
            $("body").toggleClass("filter-active");
          $(".block.filter").toggleClass("active");
        });
      }
      $(document).trigger('click');
      
      if($('body').hasClass('template-cart')) {
        var $promototaltext = $('.saso-cart-total').text();
        var $carttotal = $promototaltext.replace(' PHP','');
        var srp = parseFloat($carttotal.replace('₱','').replace(',',''));
        var vatablesale = parseFloat((srp/1.12).toFixed(2));
        var tax = parseFloat((vatablesale*0.12).toFixed(2));
        var sstotal = '₱'+ vatablesale.toLocaleString('en');
        var taxtotal = '₱'+ tax.toLocaleString('en');
        if ($promototaltext.length > 1){
          $('#saso-subtotal').text(sstotal);
          $('#tax-total').text(taxtotal);
          $('#est-total').text($carttotal);
          //temp 
          var $sslsa = $('.saso-summary-line-spend-amount'),
            sstext = $sslsa.html();
//           sstext = sstext.replace('undefined','Payday Yay!');
//           $sslsa.html(sstext);
        }
      }
      
    });
    
    /* bogo promo test */
    function getUrlVars() {
      var vars = {};
      var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
      });
      return vars;
    }
    // sorting function: arrange items according to property
    function dynamicSort(property) {
      var sortOrder = 1;
      if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
      }
      return function (a,b) {
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
      }
    }
    
    if (getUrlVars()['xmasbogo'] == 'test'){
      var in30Minutes = 1/48;
      Cookies.set('bogotest', 'test', { expires: in30Minutes });
    }
    
    
  });
})(jQuery);